import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { companyFoundedYearIncludedOptions } from 'components/organisms/contactsFilters/defaultFilters';
import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import MultiRangeFilter from '../../../../../molecules/formMultiRange';
import { FormExtraOptions } from '../../../../../molecules/formExtraOptions';
import { useCompanyFoundedYearFilter } from './useCompanyFoundedYearFilter';

export const CompanyFoundedYearFilter = ({ value, setFilters, foundedYearIncluded }) => {
  const { formSchema, onSubmit } = useCompanyFoundedYearFilter({
    setFilters,
  });

  const currentYear = new Date().getFullYear();
  const minYear = 1800;

  const initialValue = value
    ? {
        min: value.founded_year_gteq || minYear,
        max: value.founded_year_lteq || currentYear,
      }
    : null;

  const initialValues = {
    foundedYear: initialValue,
    foundedYearIncluded: foundedYearIncluded || companyFoundedYearIncludedOptions[0],
  };

  return (
    <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={onSubmit} enableReinitialize>
      {({ setFieldValue }) => (
        <Form>
          <FormikAutoSubmit />
          <Field
            name="foundedYear"
            showRange={false}
            title="Company founded year"
            min={minYear}
            max={currentYear}
            component={MultiRangeFilter}
          />
          <Field
            name="foundedYearIncluded"
            component={FormExtraOptions}
            options={companyFoundedYearIncludedOptions}
            onChange={(option) => {
              setFieldValue('foundedYearIncluded', option);
            }}
            anchorToBody
          />
        </Form>
      )}
    </Formik>
  );
};

CompanyFoundedYearFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
  foundedYearIncluded: PropTypes.object,
};

CompanyFoundedYearFilter.defaultProps = {
  value: null,
  foundedYearIncluded: null,
};
